<div class="container" style="height:400px;">
    <div class="row d-flex" style="height:100%;">
        <div class="align-self-center col-12 pending" *ngIf="paymentState === 'pending'">
            <div class="col-12 d-flex justify-content-center">
                <h5>
                    Vi færdigbehandler nu din ordre...
                </h5>
            </div>
            <div class="col-12 d-flex justify-content-center mt-4">
                <app-checkmark #checkmark></app-checkmark>
            </div>
        </div>
        <div class="align-self-center col-12 error" *ngIf="paymentState === 'error'">
            <div class="row">
                <h5 class="col-12 text-center">
                    Betalingen kunne ikke gennemføres
                </h5>
                <p class="col-12 mt-2 text-center">
                    Det var ikke muligt at gennemføre betalingen på det valgte kort.<br />
                    Prøv igen eller kontakt kundeservice på tlf. 3314 0900.
                </p>
                <p class="col-12 mt-2 text-center">
                    <button class="cta cta--primary ps-4 pe-4" (click)="onErrorOkClick()">Ok</button>
                </p>
            </div>
        </div>
    </div>
</div>
